@use '~/theme/theme' as *;
@use '~/theme/typography';

.table {
  width: 100%;
  border-collapse: collapse;

  th {
    text-align: left;
    padding: spacing(1.5) spacing(1);

    @include typography.caption;
    @include typography.medium;

    color: color(grey-600);
    text-transform: uppercase;

    &.amount {
      text-align: right;
    }
  }

  .subheading th {
    @include typography.caption;
    @include typography.medium;

    background: color(violet-100);
    padding: spacing(0.5) spacing(1);
    color: color(grey-6800);
    text-transform: none;
    border-top: border(grey-300);
  }

  td {
    padding: 0;
    height: 38px;

    @include typography.body2;
    @include typography.regular;

    border: border(grey-200);

    &:first-of-type {
      border-left: none;
    }

    &:last-of-type {
      border-right: none;
    }

    &:has([data-invalid='true']) {
      outline: 1px solid color(lobster-800);
      outline-offset: -1px;
    }

    &:has([data-focused='true']),
    &:has(:focus-visible) {
      outline: 1px solid color(violet-600);
    }

    &:first-of-type:has([data-focused='true']),
    &:first-of-type:has(:focus-visible) {
      outline: 1px solid color(violet-600);
      outline-offset: -1px;
    }

    &:last-of-type:has([data-focused='true']),
    &:last-of-type:has(:focus-visible) {
      outline: 1px solid color(violet-600);
      outline-offset: -1px;
    }

    :focus-visible {
      outline: none;
    }

    input {
      @include typography.body2;
      @include typography.regular;

      border: none;
      border-radius: 4px;
      height: 100%;
      padding: spacing(1);
      z-index: 1;
      appearance: none;
      background: none;

      &.amount {
        text-align: right;
        width: 100%;

        @include typography.tabular-nums;
      }

      &:focus-visible {
        outline: none;
      }

      &:read-only {
        color: color(grey-500);
      }
    }
  }
}

.amountColumn {
  max-width: 90px;
  min-width: 90px;
}
